module.exports = {"652222100":"巴里坤镇","652222101":"博尔羌吉镇","652222102":"大河镇","652222103":"奎苏镇","652222104":"三塘湖镇","652222200":"萨尔乔克乡","652222201":"海子沿乡","652222202":"下涝坝乡","652222205":"石人子乡","652222206":"花园乡","652222208":"大红柳峡乡","652222209":"八墙子乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652222.json
// module id = 3210
// module chunks = 0